import { Pipe, PipeTransform } from '@angular/core';
import { declarationAppUrls, notificationAppUrls } from '../app.routes';

@Pipe({
  name: 'applicationSendActionName',
  standalone: true
})
export class ApplicationSendActionNamePipe implements PipeTransform {

  transform(value?: string | null): string {
    switch (true) {
      case declarationAppUrls.includes(value || ''): {
        return 'Wyślij deklaracje';
      }
      case notificationAppUrls.includes(value || ''): {
        return 'Wyślij zgłoszenie';
      }
      default: {
        return 'Wyślij wniosek';
      }
    }
  }

}
